export const MAX_COLUMNS = 12;
export const SCREEN_SIZES = ['xs', 'sm', 'md', 'lg', 'xl'] as const;
export const BREAKPOINTS: Record<(typeof SCREEN_SIZES)[number], number> = {
  xs: 0,
  sm: 544,
  md: 768,
  lg: 992,
  xl: 1200,
};

export type BreakPointValue =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12;

export type BreakPoints =
  | BreakPointValue
  | Partial<Record<(typeof SCREEN_SIZES)[number], BreakPointValue>>;
